import { NextPageContext } from 'next';
import { PostWithMatchPostId, Stats } from 'lib/types';
import { redirectTo404 } from 'lib/constants';
import { serialize } from 'lib/helpers';
import { MatchService } from 'server/api/services/match';
import { Matches } from 'features/Matches';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { imagePostUrl } from 'lib/utils/imageUtils';
import { getCurrentUserFromContext } from 'server/api/services/auth';

export const getServerSideProps = async (
  context: NextPageContext,
) => {
  const { matchId } = context.query;
  if (!matchId) return redirectTo404;

  try {
    const currentUser = await getCurrentUserFromContext(context);
    const matchPosts = await MatchService
      .asUser(currentUser)
      .getMatchPosts(matchId as string);
    const matchMetrics = await MatchService.getMatchMetrics(matchId as string);

    if (matchPosts.length <= 0) return redirectTo404;

    return {
      props: {
        matchId,
        matchPosts: serialize(matchPosts),
        matchMetrics: serialize(matchMetrics || null),
      },
    };
  } catch (err) {
    return redirectTo404;
  }
};

interface Props {
  matchId: string;
  matchPosts: PostWithMatchPostId[];
  matchMetrics: Stats;
}

const MatchPage = ({
  matchId,
  matchPosts,
  matchMetrics,
}: Props) => {
  const description = `All ${matchMetrics.totalPosts} copies of 🔥 post by @${matchPosts[0].account}
  totaling ${matchMetrics.totalViews || 0} views, ${matchMetrics.totalLikes || 0} likes,
  ${matchMetrics.totalComments || 0} comments, and ${matchMetrics.totalShares || 0} shares`;
  return (
    <>
      <GondolaHead
        title={`Matching posts via @${matchPosts[0].account}`}
        description={description}
        url={`https://gondola.cc/matches/${matchId}`}
        image={imagePostUrl(matchPosts[0].thumbnailUrl, { isDead: !matchPosts[0].isLive })}
      />
      <Matches
        matchId={matchId}
        matchPosts={matchPosts}
        matchMetrics={matchMetrics}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default MatchPage;
